import { computedFn } from 'mobx-utils';
import { Page, Project, Space } from '../model';
import { SelectionState } from './states';
import { SelectionStore } from './store';

/** Highlights the other instances of a given selection state */
export const getLinkedStates = computedFn(
  (
    sel: SelectionState | undefined,
    store: SelectionStore,
  ): SelectionState[] => {
    if (!sel) return [];
    if (sel.section?.type !== 'reference') return [];
    const matches: SelectionState[] = [];
    collectSectionRefsInProject(store.project, sel.section.id, matches);
    return matches;
  },
);

function collectSectionRefsInProject(
  project: Project,
  findId: string,
  out: SelectionState[],
) {
  for (const space of project.spaces) {
    collectSectionRefsInSpace(space, findId, out);
  }
  collectSectionRefsInPage(project.homePage, 'home', findId, out);
}

function collectSectionRefsInSpace(
  space: Space,
  findId: string,
  out: SelectionState[],
) {
  for (const page of space.subPages) {
    collectSectionRefsInPage(page, space, findId, out);
  }
}

function collectSectionRefsInPage(
  page: Page,
  space: Space | 'home',
  findId: string,
  out: SelectionState[],
) {
  for (const section of page.sections) {
    if (section.type === 'reference' && section.id === findId) {
      out.push({ page, space, section });
    }
  }
  for (const sub of page.subPages) {
    collectSectionRefsInPage(sub, space, findId, out);
  }
}
